import React from 'react'
import { motion, useReducedMotion } from 'motion/react'

export const sectionMotion = {
  hidden: {
    opacity: 0,
    y: 18,
    filter: 'blur(2px)',
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: {
      duration: 0.28,
      ease: [0.22, 1, 0.36, 1],
    },
  },
}

export const metricMotion = {
  hidden: {
    opacity: 0,
    y: 14,
    scale: 0.98,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.24,
      ease: [0.22, 1, 0.36, 1],
    },
  },
}

export const tableRowMotion = {
  hidden: {
    opacity: 0,
    x: -8,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.2,
      ease: [0.22, 1, 0.36, 1],
    },
  },
}

export const AnimatedPage = ({ children }) => (
  <div style={{ width: '100%' }}>
    {children}
  </div>
)

export const AnimatedSection = ({ children, variant = sectionMotion, style }) => {
  const reduceMotion = useReducedMotion()

  return (
    <motion.div
      initial={reduceMotion ? false : 'hidden'}
      animate={reduceMotion ? undefined : 'visible'}
      variants={reduceMotion ? undefined : variant}
      style={{ height: '100%', ...style }}
    >
      {children}
    </motion.div>
  )
}

export const AnimatedTableRow = ({ children, ...props }) => {
  const reduceMotion = useReducedMotion()

  return (
    <motion.tr
      initial={reduceMotion ? false : 'hidden'}
      animate={reduceMotion ? undefined : 'visible'}
      variants={reduceMotion ? undefined : tableRowMotion}
      {...props}
    >
      {children}
    </motion.tr>
  )
}
